import type { HomePlanSource } from "api-types/homePlans/homePlanTypes";
import IconInboxWithArrow from "ui/icons/IconInboxWithArrow";
import IconPerson from "ui/icons/IconPerson";
import type { SvgIconProps } from "ui/icons/SVGIcon";

interface IconHomePlanSourceProps extends SvgIconProps {
  source: HomePlanSource | null | undefined;
}

export default function IconHomePlanSource({ source, size, style, ...props }: IconHomePlanSourceProps) {
  switch (source) {
    case "sales_agent": {
      return <IconPerson {...props} />;
    }
    case "web_lead": {
      return <IconInboxWithArrow {...props} />;
    }
    default: {
      return null;
    }
  }
}
